// extracted by mini-css-extract-plugin
export default {"formTitle":"FormHeader_formTitle__OilnQ","alert":"FormHeader_alert__TX1Dl","alertDanger":"FormHeader_alertDanger__EMwP1"};